"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseValidationCode = void 0;
var LicenseValidationCode;
(function (LicenseValidationCode) {
    LicenseValidationCode["UNKNOWN"] = "Unknown";
    LicenseValidationCode["SUCCESS"] = "Success";
    LicenseValidationCode["INVALID_ACTIVATION_CODE_FORMAT"] = "InvalidActivationCodeFormat";
    LicenseValidationCode["NOT_FOUND"] = "NotFound";
    LicenseValidationCode["EXPIRED"] = "Expired";
    LicenseValidationCode["BLOCKED"] = "Blocked";
    LicenseValidationCode["UNSUPPORTED_LICENSE_TYPE"] = "UnsupportedLicenseType";
    LicenseValidationCode["UNSUPPORTED_APPLICATION"] = "UnsupportedApplication";
    LicenseValidationCode["INVALID_LICENSED_OBJECTS_MINIMUM_COUNT"] = "InvalidLicensedObjectsMinimumCount";
    LicenseValidationCode["INVALID_LICENSED_OBJECTS_MAXIMUM_COUNT"] = "InvalidLicensedObjectsMaximumCount";
    LicenseValidationCode["INVALID"] = "Invalid";
    LicenseValidationCode["KES_CLOUD_ONLY"] = "KesCloudOnly";
})(LicenseValidationCode || (exports.LicenseValidationCode = LicenseValidationCode = {}));
